const IMPROPER_TITLE_BRANDINGS = [" - AirHelp", " — AirHelp"];

const endsWithAny = (suffixes: string[], search: string): boolean =>
  suffixes.some((suffix: string): boolean => search.endsWith(suffix.toLowerCase()));

const formatTitle = (title: string, brandTitle: boolean, brandSuffix: string): string | undefined => {
  if (!title) return title;

  const isAlreadyBrandedInproperly = endsWithAny(IMPROPER_TITLE_BRANDINGS, title.toLowerCase());

  if (isAlreadyBrandedInproperly) {
    const regex = new RegExp(`(${IMPROPER_TITLE_BRANDINGS.join("|")})`, "gi");
    const cleanedTitle = title.replace(regex, "");
    return formatTitle(cleanedTitle, brandTitle, brandSuffix);
  }

  const isAlreadyBrandedProperly = title.endsWith(brandSuffix);
  if (isAlreadyBrandedProperly && brandTitle) return title;
  if (isAlreadyBrandedProperly && !brandTitle) return title.replace(brandSuffix, "");

  if (brandTitle) return `${title}${brandSuffix}`;
  if (!brandTitle) return title;

  return undefined;
};

export default formatTitle;
